import {
  CompareByTimeFieldGroup,
  QuantifyDurationField,
} from '@modules/quantify/components/QuantifyQueryBuilder/Fields/DurationField';
import { useFetchQuantifyReport } from '@modules/quantify/hooks';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { isValidQuery } from '@modules/quantify/utils';
import { useEffect, useState } from 'react';

export function DurationField() {
  const compareTo = useQuantifyStore(({ query }) => query.compareTo);
  const isValidQueryState = useQuantifyStore(({ query }) =>
    isValidQuery(query),
  );

  const fetchReportData = useFetchQuantifyReport();
  const [shouldFetchReportData, setShouldFetchReportData] = useState(false);

  useEffect(() => {
    if (shouldFetchReportData) {
      setShouldFetchReportData(false);
      fetchReportData();
    }
  }, [fetchReportData, isValidQueryState, shouldFetchReportData]);

  if (compareTo?.type === 'offset' || compareTo?.type === 'timerange') {
    return (
      <CompareByTimeFieldGroup
        onRemove={() => setShouldFetchReportData(true)}
      />
    );
  }

  return <QuantifyDurationField />;
}
